import * as React from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import MailingAddressForm from './MailingAddressForm'
import MailingAddressWelcomeKit from './MailingAddressWelcomeKit'
import MailingAddressConfirmation from './MailingAddressConfirmation'
import * as DA from '../../../typeModules/events'
import * as events from '../../../events'
import * as actions from '../../../actions'

type MailingAddressProps = {
  uniqueLink: string
  trackMailingAddress?: (
    action: DA.EventActions,
    name: DA.AddressCollectionScreens
  ) => Promise<any>
  dasherId: string
  getPaymentAccount: (string) => void
  applicationStatus: {
    onboardingProgress: {
      nonDismissableAddressCollectionDate?: string
    }
  }
}

export const MailingAddress: React.FC<MailingAddressProps> = ({
  trackMailingAddress,
  uniqueLink,
  getPaymentAccount,
  dasherId,
  applicationStatus,
}) => {
  const [
    isShowingAddressConfirmation,
    setIsShowingAddressConfirmation,
  ] = React.useState(false)

  const [isAddressSubmitted, setIsAddressSubmitted] = React.useState(false)

  const nonDismissableAddressCollectionDateString = get(
    applicationStatus,
    'onboardingProgress.nonDismissableAddressCollectionDate',
    undefined
  )
  const nonDismissableAddressCollectionDate = nonDismissableAddressCollectionDateString
    ? new Date(nonDismissableAddressCollectionDateString)
    : undefined
  const hideDismissButton =
    nonDismissableAddressCollectionDate &&
    nonDismissableAddressCollectionDate.getTime() <= Date.now()

  React.useEffect(() => {
    getPaymentAccount(dasherId)
  }, [getPaymentAccount, dasherId])

  if (isAddressSubmitted) {
    return <MailingAddressWelcomeKit track={trackMailingAddress} />
  }

  if (isShowingAddressConfirmation) {
    return (
      <MailingAddressConfirmation
        back={() => setIsShowingAddressConfirmation(false)}
        onSuccess={() => setIsAddressSubmitted(true)}
        track={trackMailingAddress}
        uniqueLink={uniqueLink}
      />
    )
  }

  return (
    <MailingAddressForm
      hideDismissButton={hideDismissButton}
      nonDismissableDate={nonDismissableAddressCollectionDateString}
      track={trackMailingAddress}
      onSubmit={() => {
        setIsShowingAddressConfirmation(true)
      }}
    />
  )
}

const mapStateToProps = state => ({
  dasherId: state.application.dasherId,
  paymentAccountId: state.paymentAccount.id,
  applicationStatus: state.applicationStatus.data,
})

const mapDispatchToProps = {
  trackMailingAddress: events.trackAddressCollection,
  getPaymentAccount: actions.getPaymentAccount,
}
export default connect(mapStateToProps, mapDispatchToProps)(MailingAddress)
